import React from "react";
import { CheckCircle, X } from "lucide-react";

interface SuccessBannerProps {
  message?: string;
  onClose?: () => void;
}

export const SuccessBanner: React.FC<SuccessBannerProps> = ({ message, onClose }) => {
  return (
    <div 
      className="mx-4 mb-4 animate-slideIn"
      role="alert"
      aria-live="polite"
    >
      <div className="bg-green-50 border-l-4 border-green-500 rounded-lg shadow-lg p-4 flex items-start gap-3 ring-1 ring-green-200">
        <div className="flex-shrink-0 mt-0.5">
          <CheckCircle className="w-5 h-5 text-green-600" aria-hidden="true" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-semibold text-green-900 text-base mb-1.5">
            Успешно
          </div>
          <div className="text-sm text-green-800 leading-relaxed whitespace-pre-wrap break-words">
            {message || "Запрос выполнен успешно!"}
          </div>
        </div>
        {onClose && (
          <button
            onClick={onClose}
            className="flex-shrink-0 p-1.5 rounded-md hover:bg-green-100 active:bg-green-200 transition-colors"
            aria-label="Закрыть уведомление"
            title="Закрыть"
          >
            <X size={18} className="text-green-600" />
          </button>
        )}
      </div>
    </div>
  );
};
